import { useEffect, useState } from 'react';

export const MOBILE_MEDIA_QUERY = '(width <= 768px)';

export function useMediaQuery(query) {
  const getMatches = () => (
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false
  );

  const [matches, setMatches] = useState(getMatches);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    const onChange = () => setMatches(mediaQueryList.matches);

    onChange();
    mediaQueryList.addEventListener('change', onChange);

    return () => mediaQueryList.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

export default useMediaQuery;
